<div class="min-days-enrolled" *ngIf="jobStatusService.updatedCustomerConfig">
  <p>Students must be enrolled for</p>
  <input
    type="text"
    class="form-control enrollment-input"
    [ngClass]="{ 'validation-failed': invalidInput }"
    [(ngModel)]="
      jobStatusService.updatedCustomerConfig['enrollment.MinimumDaysEnrolled']
    "
    (ngModelChange)="validate($event)"
  />
  <p>days to be considered officially enrolled</p>
</div>
<div class="invalid-input" *ngIf="invalidInput">
  <p class="invalid-input-text">Minimum days enrolled must be an integer!</p>
</div>
